export const mapPatientInfo = (response) => {
    return response.value;
};
